import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./testimonialSection.module.css";
import TestimonialCard from "./TestimonialCard";
import { fetchArtistTestimonials } from "../../../../redux/slices/artistProfileSlice";

const TestimonialSection = () => {
  const dispatch = useDispatch();

  // Get testimonials, loading, and error state from Redux store
  const { testimonials, testimonialsLoading, testimonialsError } = useSelector(
    (state) => state.artistProfile
  );

  useEffect(() => {
    dispatch(
      fetchArtistTestimonials({
        page_size: 10,
        page_number: 1,
      })
    ); // Pass an empty object or necessary request data
  }, [dispatch]);

  return (
    <div className={classes.outerMostContainer}>
      <p className={classes.heading}>{"Testimonials"}</p>

      {testimonialsLoading && <p>Loading...</p>}
      {testimonialsError && (
        <p className={classes.error}>{testimonialsError}</p>
      )}

      <div className={classes.testimonialContainer}>
        {!testimonialsLoading &&
          !testimonialsError &&
          testimonials?.map((item, index) => (
            <TestimonialCard key={index} testimonial={item} />
          ))}
      </div>
    </div>
  );
};

export default TestimonialSection;
